import React from 'react';
import PropTypes from 'prop-types';
import styles from './ModalParts.module.scss';

/* ────────────────────────────────────────────────────────────
 * ModalBody — vertical stack wrapper for a modal's children.
 *
 * Modal renders its `children` inside `<BSModal.Body>` already,
 * which provides outer padding. ModalBody adds the consistent
 * inter-section gap so a stack of <ModalSection>s reads as one
 * form instead of stacked cards with arbitrary spacing.
 *
 *   <Modal title={...} footer={...}>
 *     <ModalBody>
 *       <ModalSection ...>...</ModalSection>
 *       <ModalSection ...>...</ModalSection>
 *     </ModalBody>
 *   </Modal>
 *
 * For a single-section modal, prefer using <ModalGrid> directly
 * — wrapping a single child in ModalBody is harmless but adds
 * noise.
 * ──────────────────────────────────────────────────────────── */

const ModalBody = ({ children, className }) => (
  <div className={[styles.body, className || ''].filter(Boolean).join(' ')}>
    {children}
  </div>
);

ModalBody.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

ModalBody.defaultProps = {
  children: null,
  className: '',
};

export default ModalBody;
